<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black"
  >
    <div class="md:max-w-full max-w-sm">
      <div class="p-8 bg-white rounded-lg relative">
        <h2 class="text-left font-bold text-lg mb-2">Buscar Producto</h2>
        <button
          type="button"
          @click="closeModal"
          class="text-red-400 absolute -mt-12 right-5 hover:bg-red-200 rounded-full p-3 "
        >
          <svg
            aria-hidden="true"
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>

        <div v-if="loading">
          <SpinnerComp
            class="w-full h-5/6 flex justify-items-center top-14 rounded-lg"
          />
        </div>

        <div v-else>
          <div class="flex items-center gap-4">
            <div class="flex-1">
              <SearchComp @update-query="updateSearchQuery" />
            </div>
            <button
              class="bg-yellow-400 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded self-center mb-4"
              @click="addOfrezco()"
            >
              Ofrezco
            </button>
          </div>

          <div class="overflow-x-auto">
            <div class="max-h-[52vh] overflow-y-auto">
              <table class="min-w-full text-sm bg-white border-gray-300">
                <thead class="bg-gray-700">
                  <tr>
                    <th
                      v-for="column in visibleColumns"
                      :key="column.key"
                      class="px-3 py-1 text-center text-white"
                    >
                      {{ column.label }}
                    </th>
                    <th class="px-3 py-1 text-white">Acción</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(row, index) in paginatedRows"
                    :key="index"
                    class="hover:bg-gray-100 transition-colors duration-200"
                  >
                    <td
                      v-for="column in visibleColumns"
                      :key="column.key"
                      class="px-3 py-1 text-xs text-gray-800 border-b"
                    >
                      <template
                        v-if="
                          [
                            'te',
                            'cantidad',
                            'precio',
                            'utilidad',
                            'cotProP',
                            'precioUtil',
                          ].includes(column.key)
                        "
                      >
                        <input
                          v-model="row[column.key]"
                          type="text"
                          :size="row[column.key]?.length || 1"
                          :maxlength="column.key === 'te' ? 9 : null"
                          class="border border-gray-300 rounded px-2 py-1 text-center justify-items-center"
                          style="min-width: 2ch"
                        />
                      </template>
                      <template v-else-if="column.key === 'idProP'">
                        <select
                          v-model="row[column.key]"
                          class="border border-gray-300 rounded px-2 py-1 w-32"
                        >
                          <option value="" disabled>
                            Seleccione un proveedor
                          </option>
                          <option
                            v-for="proveedor in proveedores"
                            :key="proveedor.idP"
                            :value="proveedor.idP"
                          >
                            {{ proveedor.nombreP }}
                          </option>
                        </select>
                      </template>
                      <template v-else>
                        {{ row[column.key] }}
                      </template>
                    </td>
                    <td
                      class="px-3 py-1 text-xs text-gray-800 border-b text-center"
                    >
                      <button
                        @click="addProduct(row)"
                        class="px-2 py-1 text-blue-600 hover:text-blue-800 focus:outline-none"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Sección de paginación para las tablas -->
        <div v-if="!loading" class="flex justify-between items-center mt-4">
          <button
            @click="prevPage"
            :disabled="currentPage === 1"
            class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 inline-block align-middle"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div>{{ currentPage }} / {{ totalPages }}</div>
          <button
            @click="nextPage"
            :disabled="currentPage === totalPages"
            class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 inline-block align-middle"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        <!--  <div class="mt-3 flex justify-end">
          <button
            @click="closeModal"
            class="py-2 px-4 text-white bg-red-600 rounded hover:bg-red-700"
          >
            Cerrar
          </button>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import SearchComp from "./SearchComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    SearchComp,
    SpinnerComp,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    selectedProducts: { type: Array, required: true },
  },
  data() {
    return {
      loading: false,
      searchQuery: "",
      currentPage: 1,
      rowsPerPage: 8,
      columns: [
        { label: "ID", key: "id_producto", hidden: true },
        { label: "Código", key: "codigo" },
        { label: "Nombre", key: "nombre" },
        { label: "Descripción del Producto", key: "descripcion" },
        { label: "Ud.", key: "unidad" },
        { label: "T.E.(d)", key: "te" },
        { label: "Cantidad", key: "cantidad" },
        { label: "Costo Prov", key: "precio" },
        { label: "Utilidad", key: "utilidad" },
        { label: "Precio Util", key: "precioUtil" },
        { label: "# Cotización P.", key: "cotProP" },
        { label: "Proveedor", key: "idProP" },
      ],
      rows: [],
      proveedores: [],
      localSelectedProducts: [],
    };
  },
  watch: {
    selectedProducts: {
      immediate: true,
      handler(newValue) {
        this.localSelectedProducts = [...newValue];
      },
    },
  },
  computed: {
    filteredRows() {
      if (!this.searchQuery) return this.rows;

      return this.rows.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredRows.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredRows.length / this.rowsPerPage);
    },
    visibleColumns() {
      return this.columns.filter((col) => !col.hidden);
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    updateSearchQuery(query) {
      this.searchQuery = query;
      this.currentPage = 1;
    },
    addOfrezco() {
      if (
        !this.localSelectedProducts.find((product) => product.codigo === "")
      ) {
        let row = {
          id: 73,
          codigo: "",
          sku: null,
          nombre: "",
          descripcion: "Ofrezco:",
          unidad: "pza",
          utilidad: 0,
          Stock: null,
          precio: null,
          precioUtil: null,
          cotProP: null,
          idProP: 0,
          nombreProveedor: "Sin Proveedor",
        };
        this.localSelectedProducts.push(row);
        this.$emit("products-updated", this.localSelectedProducts);
      } else {
        alert("El producto ya está seleccionado.");
      }
    },
    addProduct(row) {
      if (
        !this.localSelectedProducts.find(
          (product) => product.codigo === row.codigo
        )
      ) {
        this.localSelectedProducts.push(row);
        this.$emit("products-updated", this.localSelectedProducts);
      } else {
        alert("El producto ya está seleccionado.");
      }
    },
    getProducts() {
      this.loading = true;
      this.$axios
        .get("/getPro")
        .then((response) => {
          this.rows = response.data.producto;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProveedores() {
      this.$axios.get("/getPrv2").then((response) => {
        this.proveedores = response.data.proveedores;
      });
    },
  },
  mounted() {
    this.getProducts();
    this.getProveedores();
  },
};
</script>
